import { useMemo } from 'react'

import { useModals } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

const AuditLog = () => {
  const modalContext = useModals()
  const pageContext = useMemo(() => ({
    callbacks: {},
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default AuditLog
